import { render, staticRenderFns } from "./car-tab.vue?vue&type=template&id=2efc896b&scoped=true&"
import script from "./car-tab.vue?vue&type=script&lang=js&"
export * from "./car-tab.vue?vue&type=script&lang=js&"
import style0 from "./car-tab.vue?vue&type=style&index=0&id=2efc896b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc896b",
  null
  
)

export default component.exports